import { useEffect, useState } from 'react';
import ShoppingAppShowcase from './ShoppingAppShowcase';

const SHOWCASE_REVEAL_TIMEOUT_MS = 2600;

function ShoppingDemoPage() {
  const [stylesReady, setStylesReady] = useState(false);
  const [showcaseReady, setShowcaseReady] = useState(false);
  const [displayReady, setDisplayReady] = useState(false);

  useEffect(() => {
    const existingLink = document.getElementById('shopping-demo-stylesheet');

    if (existingLink) {
      setStylesReady(true);
      return undefined;
    }

    const link = document.createElement('link');
    link.id = 'shopping-demo-stylesheet';
    link.rel = 'stylesheet';
    link.href = `${process.env.PUBLIC_URL || ''}/shopping-demo.css`;
    link.onload = () => {
      window.requestAnimationFrame(() => {
        setStylesReady(true);
      });
    };
    link.onerror = () => {
      setStylesReady(true);
    };
    document.head.appendChild(link);

    return () => {
      link.remove();
    };
  }, []);

  const isReady = stylesReady && showcaseReady;

  useEffect(() => {
    if (!isReady) {
      setDisplayReady(false);
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setDisplayReady(true);
    }, 220);

    return () => window.clearTimeout(timer);
  }, [isReady]);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setDisplayReady(true);
    }, SHOWCASE_REVEAL_TIMEOUT_MS);

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <section className="shopping-demo-page">
      {!displayReady ? (
        <div className="shopping-demo-loader" role="status" aria-live="polite">
          <div className="shopping-demo-loader-panel">
            <div className="shopping-demo-loader-glow shopping-demo-loader-glow-one" />
            <div className="shopping-demo-loader-glow shopping-demo-loader-glow-two" />

            <div className="shopping-demo-loader-topbar">
              <span />
              <span />
              <span />
            </div>

            <div className="shopping-demo-loader-badge">ATA Code House</div>

            <div className="shopping-demo-loader-stage">
              <div className="shopping-demo-loader-rings">
                <span />
                <span />
                <span />
              </div>
              <div className="shopping-demo-loader-orb">
                <div className="shopping-demo-loader-orb-core" />
                <div className="shopping-demo-loader-scanline" />
              </div>
            </div>

            <div className="shopping-demo-loader-copy">
              <strong>Preparing Shopping App Showcase</strong>
              <p>Loading branded UI flows, polished product cards, and smooth live interactions.</p>
            </div>

            <div className="shopping-demo-loader-status">
              <span>ui.system.boot()</span>
              <span>assets.sync()</span>
              <span>showcase.render()</span>
            </div>

            <div className="shopping-demo-loader-progress" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
            </div>
          </div>
        </div>
      ) : null}

      <div className={`shopping-demo-stage${displayReady ? ' is-ready' : ''}`}>
        <ShoppingAppShowcase onReady={() => setShowcaseReady(true)} />
      </div>
    </section>
  );
}

export default ShoppingDemoPage;
